<template>
  <div class="lobby">
    <Header />
    <div class="body">
      <RecentGames v-if="state.recentGamesList.length"
                   :data="state.recentGamesList" />
      <Games v-if="state.gamesList.length"
             :data="state.gamesList"
             :class="{ hasRecent: state.recentGamesList.length }" />
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue';
import { orderBy } from 'lodash';
import Header from './components/Header';
import Games from './components/Games';
import RecentGames from './components/RecentGames';

export default {
  name: 'App',
  components: { Header, Games, RecentGames },
  setup() {
    const state = reactive({
      gamesList: [],
      recentGamesList: [],
    });

    const getRecentGames = (games) => {
      const recentGames = games.filter((game) => game.playedRecently);
      state.recentGamesList = orderBy(recentGames, ['playedRecentlyIndex', 'displayName'], ['asc', 'asc']);
    };

    window.onmessage = (event) => {
      if (event.data.action === 'InitLobby') {
        state.gamesList = event.data.value;
        getRecentGames(event.data.value);
      }
    };

    return {
      state,
    };
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Dancing+Script&family=Roboto:wght@400;700&display=swap");
@import "./style/scrollbar";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  color: #fff;
  user-select: none;
}

.lobby {
  width: 100%;
  height: 100%;
  padding: 14px 20px;
  padding-right: 0;
  background: linear-gradient(197.56deg, #8f2b8b 0%, #24252f 100%);
  box-sizing: border-box;
  transition: all 0.14s ease;

  .body {
    overflow-y: auto;
    @include scrollbar();
    max-height: calc(100vh - 52px);
  }
}
</style>
